import React, {useLayoutEffect, useState} from 'react';
import {Switch, Select} from 'antd';
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  CloseOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useOrganization } from "../../context/organizationContext";
import {PHOTO_PARAMS} from "./photo-params";
import {useSearchParams} from "react-router-dom";



const PostPhotoEditor = ({ index, image, onImageChange }) => {
  const { t } = useTranslation();
  const { organization } = useOrganization();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isModalOpen, setIsModalOpen] = useState(index === Number(searchParams.get('image')));
  const [logoParams, setLogoParams] = useState({
    visible: image?.params?.logo?.visible ?? false,
    position: image?.params?.logo?.position ?? PHOTO_PARAMS.POSITIONS[0].value,
    scale: image?.params?.logo?.scale ?? PHOTO_PARAMS.SCALES[0].value,
  });
  // console.log('SPparams', searchParams.get('image'));
  const handleApply = () => {

    onImageChange({
      ...image,
      params: {
        logo: logoParams
      }
    });
  };

  const handleChangePosition = (position) => {
    setLogoParams(prev => ({
      ...prev,
      position
    }));
  };

  const handleChangeScale = (scale) => {
    setLogoParams(prev => ({
      ...prev,
      scale
    }));
  };

  const handleChangeVisible = (visible) => {
    setLogoParams(prev => ({
      ...prev,
      visible
    }));
  };

  const handleModalSetVisible = (state= false) => {
    setIsModalOpen(state);
    if (state) {
      setSearchParams((prev) => {
        prev.set("image", index);
        return prev;
      });
      // document.body.style.overflow = 'hidden';
    } else {
      // document.body.style.overflow = 'unset';
      setSearchParams((prev) => {
        prev.delete("image", index);
        return prev;
      });
    }
  };

  useLayoutEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isModalOpen]);

  if (!image?.imageUrl) return null;

  return (
  <>
    <img
        src={image?.imageUrl}
        alt="Preview"
        className="max-w-full w-full h-auto rounded-lg shadow-md cursor-pointer"
        onClick={() => handleModalSetVisible(true)}
    />
    <div
      className={`w-full h-full fixed top-0 left-0 flex justify-center items-center flex-col bg-black/75 backdrop-blur-sm ${
        isModalOpen ? 'opacity-100 z-[1000] overflow-auto' : 'opacity-0 pointer-events-none'
      } transition-all duration-300 ease-in-out`}
      onClick={() => handleModalSetVisible(false)}
    >
      <div
        className={`py-5 flex justify-center items-center flex-col`}
      >

      <div
        className="relative w-full max-w-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <CloseOutlined
            className={`fixed top-2 right-2 cursor-pointer z-50 text-white/75 hover:text-white text-3xl ${isModalOpen ? 'opacity-100' : 'opacity-0'} transition-all duration-300 ease-in-out`}
            onClick={() => handleModalSetVisible(false)}
        />
        <img
          src={image?.imageUrl}
          alt="Preview"
          className={`w-full h-auto rounded-lg shadow-md my-5 ${isModalOpen ? 'scale-100' : 'scale-0'} transition-all duration-300 ease-in-out`}
        />
      </div>

      <div
        className={
          `${isModalOpen ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'} transition-all duration-300 ease-in-out` +
          'sticky lg:fixed mx-auto bottom-2 left-2 right-2 lg:w-full lg:max-w-5xl lg:left-1/2 lg:-translate-x-1/2 bg-white/75 shadow-md p-4 rounded-xl ' +
          ' grid grid-cols-1 md:grid-cols-3 gap-2'
        }
        onClick={(e) => e.stopPropagation()}
      >

        <div className='flex items-center gap-2'>
          <label htmlFor='visibleLogo' className='text-sm font-medium text-gray-700'>
            {t(`post.visibleLogoTitle`)}
          </label>
          <Switch
              id="visibleLogo"
              onChange={handleChangeVisible}
              checked={logoParams.visible}
              checkedChildren={<EyeOutlined />}
              unCheckedChildren={<EyeInvisibleOutlined />}
          />
        </div>

        <div className='flex items-center gap-2'>
          <Select
              disabled={!logoParams.visible}
              onChange={handleChangePosition}
              value={logoParams.position}
              className="w-36"
          >
            {PHOTO_PARAMS.POSITIONS.map(({value, label}) => (
                <Select.Option key={value} value={value}>
                  {t(`post.logoPositions.${label}`)}
                </Select.Option>
            ))}
          </Select>
          <Select
              disabled={!logoParams.visible}
              onChange={handleChangeScale}
              value={logoParams.scale}
              className="w-36"
          >
            {PHOTO_PARAMS.SCALES.map(({value, label}) => (
                <Select.Option key={value} value={value}>
                  {t(`post.logoScales.${label}`)}
                </Select.Option>
            ))}
          </Select>
        </div>

        <div className='flex items-center justify-end gap-2'>
          <button
            className='logout-button !mt-0 !py-2 !px-4 !w-auto !text-sm'
            onClick={handleApply}
          >
            {t(`post.apply`)}
          </button>
        </div>

      </div>

      </div>
    </div>
  </>
  );
};

export default PostPhotoEditor;